import { MessageService } from "primeng/api";

import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ClassUser } from "src/app/models/class-user";
import { Race } from "src/app/models/race";
import { RaceClass } from "src/app/models/race-class";
import { Registration } from "src/app/models/registration";
import { CommonService } from "src/app/services/common.service";
import { ProgressService } from 'src/app/services/progress.service';
import { RaceProgressRegistrationDataRaw } from 'src/app/models/interfaces/race_progress_registration_data_raw.interface';
import { SettingsService } from "src/app/services/settings.service";

@Component({
  selector: "app-documents-participants-table",
  templateUrl: "./documents-participants-table.component.html",
  styleUrls: ["./documents-participants-table.component.scss"],
})
export class DocumentsParticipantsTableComponent implements OnInit, OnDestroy {
  @Input() race!: Race;
  @Input() classData!: RaceClass;
  @Input() raceClasses: RaceClass[] = [];
  // @Input() rUid: string;
  // @Input() utcOffsetMinutes: number;
  // @Input() infoColumnName: string;
  @Input() filter!: string;
  @Output() onMenuOpen = new EventEmitter<Registration>();

  // Getter для отфильтрованных данных
  get filteredRegistrations(): Registration[] {
    if (!this.filter || this.filter === 'no_filter') {
      return this.classData.registrations;
    }

    return this.classData.registrations.filter(reg => {
      switch (this.filter) {
        case 'not_payed_competitors':
          return !reg.startFee || Number(reg.startFee) === 0;
        
        case 'no_docs':
          return !reg.documents || reg.documents.length === 0 || 
                 reg.documents.every(doc => !doc.files || doc.files.length === 0);
        
        case 'not_processed_competitors':
          return reg.doc_new;
        
        case 'with_errors_in_docs':
          return reg.doc_invalid;
        
        case 'not_confirmed':
          return !reg.allDocumentsValid;
        
        case 'under_18':
          if (!this.race?.date || !reg.user?.birthdate) return false;
          const raceDate = new Date(this.race.date);
          const birthDate = new Date(reg.user.birthdate);
          const ageAtRace = raceDate.getFullYear() - birthDate.getFullYear();
          return ageAtRace < 18;
        
        case 'under_16':
          if (!this.race?.date || !reg.user?.birthdate) return false;
          const raceDate16 = new Date(this.race.date);
          const birthDate16 = new Date(reg.user.birthdate);
          const ageAtRace16 = raceDate16.getFullYear() - birthDate16.getFullYear();
          return ageAtRace16 < 16;
        
        case 'deleted_reg':
          return reg.deleted === true;
        
        default:
          return true;
      }
    });
  }

  dialogStartFee = false;
  dialogConfirmed = false;
  dialogData!: any;
  dialogRegForm: boolean = false;
dialogRegistrationTimeVisible = false;
  dialogRegistrationTimeRow: Registration | null = null;
  dialogRegistrationTimeValue: Date | null = null;
  dialogRegistrationTimeText = '';

  tempStartNumber = "";
  tempRegInfo = "";
  tempFee = "";
  tempTeamInfo = "";
  tempChronoTag = 0;
  tempOrgComment = "";
  tempRegistrationTime: Date | null = null;

  selectedRegistration: ClassUser | null = null;

  totals = {
    competitors: 0,
    fee: 0,
    gpsTrackers: 0,
    chronoTags: 0,
  };

  constructor(
    public appSettings: SettingsService,
    private progressService: ProgressService,
    public messageService: MessageService,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.progressService.refreshTableData.subscribe(() => {
      this.updateTotals();
    });
  }

  ngOnDestroy(): void {
    // this.dataService.refreshTableData.unsubscribe();
  }

  clickByTd(field: string, rowData: Registration) {
    if (field === "startFee") {
      this.dialogStartFee = true;
      this.dialogData = {
        ...rowData,
        name: this.appSettings.getTranslate("change_start_fee"),
      };
    }
    if (field === "allDocumentsValid") {
      this.progressService
        .getParticipantData(
          this.race.rUid,
          this.classData.clUid,
          rowData.user.cUid,
          rowData.deleted
        )
        .then((participantData) => {
          if (participantData) {
            rowData = participantData;
            this.dialogData = {
              ...rowData,
              name: this.appSettings.getTranslate("doc_check_header"),
            };
            this.dialogConfirmed = true;
            this.cdr.detectChanges();
          }
        });
    }
    if (field === "gpsTracker") {
      this.copyToClipboard(rowData.gpsTracker)
        .then(() => {
          this.messageService.clear();
          this.messageService.add({
            severity: "success",
            summary:
              this.appSettings.translate[this.appSettings.selectedLang][
              "data_to_clipboard"
              ],
          });
        })
        .catch((err) => {
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: err.stack || err.message || err.toString(),
          });
        });
    }
    if (field === "name") {
      this.selectedRegistration = new ClassUser(rowData.user.cUid, rowData.clUid, Number(rowData.startNumber), rowData.info);
      this.selectedRegistration.saved = true;
      this.selectedRegistration.user = rowData.user;
      this.dialogRegForm = true;
      this.cdr.detectChanges();
    }
  }

  closeRegistrationDataDialog(event: any) {
    this.dialogRegForm = false;
    this.commonService.closeRegistrationDialog.emit();
  }

  setTmpStartNumber(rowData: Registration) {
    this.tempStartNumber = rowData.startNumber;
  }

  setTmpRegInfo(rowData: Registration) {
    this.tempRegInfo = rowData.info;
  }

  setTmpTeamInfo(rowData: Registration) {
    this.tempTeamInfo = rowData.user.team;
  }

  sanitizePositiveInt(value: number): number {
    if (isNaN(value) || value < 0) {
      return 0;
    }
    return Math.floor(value);
  }

  setTmpFee(rowData: Registration) {
    this.tempFee = rowData.startFee.toString();
  }

  setTmpChronoTag(rowData: Registration) {
    this.tempChronoTag = rowData.chronoTag;
  }

  setTmpOrgComment(rowData: Registration) {
    this.tempOrgComment = rowData.orgComment;
  }

setTmpRegistrationTime(rowData: Registration) {
    if (rowData.registrationTime && rowData.registrationTime.getTime() > 0) {
      this.tempRegistrationTime = new Date(rowData.registrationTime);
    } else {
      this.tempRegistrationTime = null;
    }
  }

  onCellClickRegistrationTime(rowData: Registration) {
    // Выставляем temp ДО того, как p-cellEditor переключится в режим ввода
    this.setTmpRegistrationTime(rowData);
  }

onTimeClick(rowData: Registration) {
    this.dialogRegistrationTimeRow = rowData;
    if (rowData.registrationTime && rowData.registrationTime.getTime() > 0) {
      this.dialogRegistrationTimeValue = new Date(rowData.registrationTime);
      this.dialogRegistrationTimeText = this.formatDateTime(rowData.registrationTime);
    } else {
      this.dialogRegistrationTimeValue = null;
      this.dialogRegistrationTimeText = '';
    }
    this.dialogRegistrationTimeVisible = true;
  }

  // Форматирует Date в строку dd.MM.yyyy HH:mm:ss
  private formatDateTime(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  }

  // Парсит строку dd.MM.yyyy HH:mm:ss в Date
  private parseDateTime(str: string): Date | null {
    const match = str.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/);
    if (!match) return null;
    const [_, day, month, year, hours, minutes, seconds] = match.map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  onRegistrationTimeTextChange() {
    const parsed = this.parseDateTime(this.dialogRegistrationTimeText);
    if (parsed) {
      this.dialogRegistrationTimeValue = parsed;
    }
  }

  onRegistrationTimeSelect() {
    if (this.dialogRegistrationTimeValue) {
      this.dialogRegistrationTimeText = this.formatDateTime(this.dialogRegistrationTimeValue);
    }
  }

  saveRegistrationTimeDialog() {
    if (!this.dialogRegistrationTimeRow || !this.dialogRegistrationTimeValue) return;

    const rowData = this.dialogRegistrationTimeRow;
    const newTime = this.dialogRegistrationTimeValue;

    // Отправляем только если значение действительно изменилось
    if (rowData.registrationTime && newTime.getTime() === rowData.registrationTime.getTime()) {
      this.dialogRegistrationTimeVisible = false;
      return;
    }

    const time = newTime.getTime();

    this.progressService
      .saveRegistrationTime(this.race.rUid, rowData.user.cUid, time)
      .then(() => {
        rowData.registrationTime = new Date(time);
        const participant = this.classData.registrations.find(
          (p) => p.user.cUid === rowData.user.cUid
        );
        if (participant) {
          participant.registrationTime = new Date(time);
        }
        this.dialogRegistrationTimeVisible = false;
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary: this.appSettings.translate[this.appSettings.selectedLang]["save_success"],
        });
      });
  }

  onChangeRegistrationTime(rowData: Registration) {
    if (!this.tempRegistrationTime) return;

    // Отправляем только если значение действительно изменилось
    if (rowData.registrationTime && this.tempRegistrationTime.getTime() === rowData.registrationTime.getTime()) {
      return;
    }

    // Перевод из локального времени гонки обратно в UTC+0
    const utcTime = this.tempRegistrationTime.getTime() - this.race.city.utcOffset * 60 * 1000;

    this.progressService
      .saveRegistrationTime(this.race.rUid, rowData.user.cUid, utcTime)
      .then(() => {
        rowData.registrationTime = new Date(utcTime);
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === rowData.user.cUid
        );
        if (participant) {
          participant.registrationTime = new Date(utcTime);
        }
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
});
  }

  onChangeStartNumber(rowData: RaceProgressRegistrationDataRaw) {
    if (this.tempStartNumber === "" || this.tempStartNumber === "0") {
      this.commonService.confirm({
        message:
          this.appSettings.translate[this.appSettings.selectedLang][
          "delete_number_confirm"
          ],
        header:
          this.appSettings.translate[this.appSettings.selectedLang][
          "change_registration"
          ],
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.tempStartNumber = "";
          this.changeStartNumber(rowData);
        },
        reject: () => { },
      });
    } else {
      this.changeStartNumber(rowData);
    }
  }

  changeStartNumber(rowData: RaceProgressRegistrationDataRaw) {
    const registration = new Registration(rowData);
    registration.startNumber = this.tempStartNumber;
    this.progressService
      .saveStartNumber(registration, this.race.rUid)
      .then(() => {
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === rowData.user.cUid
        );

        if (!participant) return;
        participant.startNumber = rowData.startNumber;
        rowData.startNumber = this.tempStartNumber;
        this.updateTotals();
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
      });
  }

  onChangeRegInfo(rowData: Registration) {
    rowData.info = this.tempRegInfo;
    this.progressService
      .saveRegInfo(rowData, this.race.rUid)
      .then(() => {
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === rowData.user.cUid
        );
        if (!participant) return;
        participant.startFee = rowData.startFee;
        this.updateTotals();
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
      });
  }

  onChangeTeamInfo(rowData: Registration) {
    rowData.user.team = this.tempTeamInfo;
    this.progressService
      .saveTeamInfo(rowData, this.race.rUid)
      .then(() => {
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === rowData.user.cUid
        );
        if (!participant) return;
        participant.user.team = rowData.user.team;
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
      });
  }

  onChangeFee(rowData: Registration) {
    rowData.startFee = this.tempFee;
    this.progressService
      .saveStartFee(rowData, this.race.rUid)
      .then(() => {
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === rowData.user.cUid
        );
        if (!participant) return;
        participant.startFee = rowData.startFee;
        this.updateTotals();
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
      });
  }

  onChangeChronoTag(rowData: RaceProgressRegistrationDataRaw) {
    if (!this.tempChronoTag) {
      this.commonService.confirm({
        message:
          this.appSettings.translate[this.appSettings.selectedLang][
          "delete_tag_confirm"
          ],
        header:
          this.appSettings.translate[this.appSettings.selectedLang][
          "change_registration"
          ],
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.tempChronoTag === 0;
          this.changeChronoTag(rowData);
        },
        reject: () => { },
      });
    } else {
      this.changeChronoTag(rowData);
    }
  }

  changeChronoTag(rowData: RaceProgressRegistrationDataRaw) {
    const registration = new Registration(rowData);
    registration.chronoTag = this.tempChronoTag;
    this.progressService
      .saveChronoTag(registration, this.race.rUid)
      .then(() => {
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === rowData.user.cUid
        );
        if (!participant) return;
        participant.chronoTag = rowData.chronoTag;
        rowData.chronoTag = this.tempChronoTag;
        this.updateTotals();
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
      });
  }

  onChangeOrgComment(rowData: Registration) {
    rowData.orgComment = this.tempOrgComment;
    this.progressService
      .saveOrgComment(rowData, this.race.rUid)
      .then(() => {
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === rowData.user.cUid
        );
        if (!participant) return;
        participant.orgComment = rowData.orgComment;
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
      });
  }

  copyToClipboard(textToCopy) {
    return new Promise((resolve, reject) => {
      // Проверяем, поддерживает ли браузер navigator.clipboard
      if ((navigator as any).clipboard && window.isSecureContext) {
        (navigator as any).clipboard
          .writeText(textToCopy)
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        // Альтернативный метод для старых браузеров
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          resolve(true);
        } catch (err) {
          reject(err);
        }
        document.body.removeChild(textArea); // Убираем временный элемент
      }
    });
  }

  saveDocuments(dialogData: Registration) {
    this.dialogConfirmed = false;
    this.progressService
      .saveDocumentData(dialogData, this.race.rUid)
      .then(() => {
        const participant = this.classData.registrations.find(
          (participant) => participant.user.cUid === dialogData.user.cUid
        );
        if (!participant) return;
        participant.documents = dialogData.documents;
        participant.startFee = dialogData.startFee;
        participant.allDocumentsValid = dialogData.allDocumentsValid;
        this.updateTotals();
        this.messageService.clear();
        this.messageService.add({
          severity: "success",
          summary:
            this.appSettings.translate[this.appSettings.selectedLang][
            "save_success"
            ],
        });
      });
  }

  updateTotals() {
    this.totals = this.classData.registrations.reduce(
      (acc, participant) => {
        acc.competitors += 1 + (participant.crew ? participant.crew.length : 0);
        acc.fee += Number(participant.startFee);
        if (participant.gpsTracker) acc.gpsTrackers += 1;
        if (participant.chronoTag) acc.chronoTags += 1;
        return acc;
      },
      {
        competitors: 0,
        fee: 0,
        gpsTrackers: 0,
        chronoTags: 0,
      }
    );
  }

  calculateLocalTime(rowData: Registration): string {
    let dateString = "-";
    // Форматирование как строка
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "UTC",
      hour12: false,
    };

    if (rowData.registrationTime.getTime() > 0) {
      // Создание даты в UTC
      const utcTime =
        rowData.registrationTime.getTime() + this.race.city.utcOffset * 60 * 1000; // добавление смещения в миллисекундах
      const localDate = new Date(utcTime); // Создание нового объекта Date

      // Преобразование локальной даты в строку с нужным форматом
      dateString = localDate.toLocaleString("ru-RU", options).replace(",", "");
    }

    if (rowData.deleted) {
      let localDateDel = "-";
      if (Number(rowData.deletedTimestamp) > 0) {
        const utcTimeDel =
          new Date(Number(rowData.deletedTimestamp)).getTime() +
          this.race.city.utcOffset * 60 * 1000;
        localDateDel = new Date(utcTimeDel).toLocaleString("ru-RU", options).replace(",", "");
      }

      dateString =
        dateString +
        "/<br>" +
        localDateDel +
        "<br>" +
        rowData.deletedAuthor;
    }

    return dateString;
  }

  showMenu(participant: Registration) {
    participant.className = this.classData.name;
    this.onMenuOpen.emit(participant);
  }
}
